import * as Sentry from "@sentry/vue";
import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware(() => {
    const user = useSanctumUser<KadeweUser>();

    if (!user.value) {
        Sentry.setUser(null);
        return;
    }

    Sentry.setUser({
        id: user.value?.id,
    });
});
